import React from 'react';

const TablaVotosPartidos_FilaPartidoCurules = props => {
  const cargElectos = props.data.act.cargElectos;
  return (
    // <td className="cargos">{props.data.act.cargElectos}</td>
    // <td className="cargos">{Number(props.data.act.cargEmpatados)>0?cargElectos+'*':cargElectos}</td>
    <td className="cargos">{
      Number(cargElectos)===0
        ? ""
        : Number(props.data.act.cargEmpatados)>0
          ?cargElectos+'*'
          :cargElectos}</td>
  );
};

export default TablaVotosPartidos_FilaPartidoCurules;
